<template>
  <div class="home-page-container">
    <!-- TEMPORARILY DISABLED <div class="home-page-text" v-html="homePageText"></div> -->
    <div class="home-page-column">
      <PageView :id="generalSettings['home_page']" :no-title="true" />
      <PostsView :id="generalSettings['home_page_category_1']" :limit="true" />
      <!-- <PostsView :id="generalSettings['home_page_category_2']" :limit="true"/> -->
    </div>
  </div>
</template>

<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import PostsView from '@/views/PostsView.vue';
import PageView from '@/views/PageView.vue';

export default {
	name: 'HomePage',
	mixins: [contentDataLoaderMixin, staticDataLoaderMixin],
	components: { PostsView, PageView },
	data() {
		return {};
	},
	created() {
		this.$root.$emit('resetCoverImages');
	},
	computed: {
		homePageText() {
			const homePage = this.getContentById(
				'pages',
				this.generalSettings.home_page,
			);
			if (homePage) {
				return JSON.parse(homePage.body)[this.language];
			}

			return '';
		},
	},
};
</script>

<style src="#/styles/views/HomePage/HomePage.less" lang="less" scoped></style>
